// Orden de Delivery imprimible (remitente = empresa propia, destinatario = cliente del Catastro).
// Formatos: "doble_a5" (A4 horizontal, 2 vías A5 lado a lado) | "a4" | "ticket" (80mm).

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const esc = (v) => String(v ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

async function traerCliente(token, empresaId) {
  if (!token || !empresaId) return null;
  try {
    const r = await fetch(`${API}/admin/entidades/${empresaId}`, { headers: { Authorization: `Bearer ${token}` } });
    return r.ok ? await r.json() : null;
  } catch { return null; }
}

function bloque(d, via) {
  const logo = d.logoUrl ? `<img class="logo" src="${esc(d.logoUrl)}" alt="">` : "";
  return `
  <div class="via">
    ${via ? `<div class="via-tag">${esc(via)}</div>` : ""}
    <div class="emisor">
      ${logo}
      <div class="e-nombre">${esc(d.emisorNombre)}</div>
      ${d.emisorRuc ? `<div class="e-line">RUC: ${esc(d.emisorRuc)}</div>` : ""}
      ${d.emisorDireccion ? `<div class="e-line">Dirección: ${esc(d.emisorDireccion)}</div>` : ""}
      ${d.emisorTelefono ? `<div class="e-line">Teléfono: ${esc(d.emisorTelefono)}</div>` : ""}
    </div>
    <hr>
    <div class="titulo">ORDEN DE DELIVERY<br>FACTURA DE VENTA: ${esc(d.numero)}</div>
    <hr>
    <div class="fila"><b>Fecha:</b> ${esc(d.fecha)} <span class="sp"></span><b>Hora:</b> ${esc(d.hora)}</div>
    <div class="fila"><b>Repartidor:</b> ${esc(d.repartidor || "________________________")}</div>
    <div class="sec">DATOS DEL DESTINATARIO</div>
    <div class="fila"><b>Cliente:</b> ${esc(d.clienteNombre)}</div>
    ${d.clienteDoc ? `<div class="fila"><b>RUC/CI:</b> ${esc(d.clienteDoc)}</div>` : ""}
    <div class="fila"><b>Celular:</b> ${esc(d.clienteTelefono || "-")}</div>
    <div class="fila"><b>Dirección de entrega:</b> ${esc(d.direccion || "-")}</div>
    ${d.referencia ? `<div class="fila"><b>Ref. Entrega:</b> ${esc(d.referencia)}</div>` : ""}
    <div class="firma"><div class="linea"></div>Firma de Recibido (Cliente)</div>
    <div class="pie">¡Buen viaje, conduce con cuidado!</div>
  </div>`;
}

export async function imprimirOrdenDelivery({ factura, token, empresaPropia, formato = "doble_a5" }) {
  const f = factura || {};
  const cli = await traerCliente(token, f.empresa_id);
  const entrega = f.delivery || {};
  const fechaIso = f.fecha || "";
  const fecha = fechaIso ? fechaIso.split("-").reverse().join("/") : new Date().toLocaleDateString("es-PY");
  const created = f.created_at ? new Date(f.created_at) : new Date();
  const d = {
    logoUrl: f.emisor_logo_url || empresaPropia?.logo_url || (empresaPropia?.logos || [])[0]?.url || "",
    emisorNombre: f.emisor_nombre_fantasia || f.emisor_razon_social || empresaPropia?.nombre_fantasia || empresaPropia?.razon_social || empresaPropia?.nombre || "",
    emisorRuc: f.emisor_ruc || empresaPropia?.ruc || "",
    emisorDireccion: f.emisor_direccion || empresaPropia?.direccion || "",
    emisorTelefono: f.emisor_telefono || empresaPropia?.telefono || "",
    numero: f.numero || f.numero_boleta || "",
    fecha,
    hora: created.toLocaleTimeString("es-PY", { hour: "2-digit", minute: "2-digit" }),
    repartidor: entrega.repartidor || "",
    clienteNombre: cli?.razon_social || cli?.nombre || f.empresa_nombre || "",
    clienteDoc: cli?.ruc || f.ruc || "",
    clienteTelefono: cli?.telefono || f.cliente_telefono || "",
    direccion: entrega.direccion || [cli?.direccion, cli?.ciudad].filter(Boolean).join(", ") || f.direccion || "",
    referencia: entrega.referencia || "",
  };

  const w = window.open("", "_blank");
  if (!w) return false;
  const base = `*{box-sizing:border-box}body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#000}
    .via{padding:14px 18px;position:relative}.via-tag{text-align:right;font-weight:bold;font-size:12px}
    .emisor{text-align:center}.logo{max-height:70px;max-width:60%;object-fit:contain}
    .e-nombre{font-size:16px;font-weight:bold;margin-top:4px}.e-line{font-size:12px}
    hr{border:0;border-top:2px solid #000;margin:10px 0}
    .titulo{text-align:center;font-size:18px;font-weight:bold;line-height:1.35}
    .fila{font-size:13px;margin:5px 0}.sp{display:inline-block;width:40px}
    .sec{font-weight:bold;font-size:14px;margin-top:14px}
    .firma{text-align:center;font-size:12px;margin-top:46px}.linea{border-top:1px solid #000;width:75%;margin:0 auto 4px}
    .pie{text-align:center;font-style:italic;font-size:12px;margin-top:14px}`;
  let html;
  if (formato === "ticket") {
    html = `<html><head><title>Orden de Delivery</title><style>${base}
      @page{size:80mm auto;margin:3mm}body{width:74mm}.via{padding:2px}.titulo{font-size:14px}.fila{font-size:11px}.logo{max-height:50px}</style></head>
      <body>${bloque(d, "")}</body></html>`;
  } else if (formato === "a4") {
    html = `<html><head><title>Orden de Delivery</title><style>${base}
      @page{size:A4 portrait;margin:12mm}.via{padding:10px 24px}.titulo{font-size:22px}.fila{font-size:15px}.sec{font-size:17px}</style></head>
      <body>${bloque(d, "")}</body></html>`;
  } else {
    html = `<html><head><title>Orden de Delivery</title><style>${base}
      @page{size:A4 landscape;margin:8mm}
      .wrap{display:flex;width:100%;height:190mm}.wrap .via{width:50%;border-right:1px dashed #000}.wrap .via:last-child{border-right:0}</style></head>
      <body><div class="wrap">${bloque(d, "Original - Repartidor")}${bloque(d, "Duplicado - Comercio")}</div></body></html>`;
  }
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => { try { w.print(); } catch (_e) { /* noop */ } }, 400);
  return true;
}
